import classNames from 'classnames';
export default function cn(...args) {
  return classNames(args);
}
